import { HStack, VStack } from '@primerai/thread';
import styled from 'styled-components';

export const NAVBAR_ICON_SIZE = '28px';

export const Container = styled(VStack)`
  height: 100vh;
  background: ${({ theme }) => theme.colors.$background.elevation3};
`;

export const SecondaryActions = styled(HStack)`
  gap: ${({ theme }) => theme.space.$4};
`;

export const NavBar = styled(HStack)`
  width: 100%;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 0 ${({ theme }) => theme.space.$5};

  border-bottom: 1px solid ${({ theme }) => theme.colors.$border.default};
`;

export const Content = styled.div`
  height: 100%;
  padding: 0 ${({ theme }) => theme.space.$5};
`;

export const ButtonWrapper = styled.div`
  cursor: pointer;
  & > * {
    display: inline-block;
    margin: 0 auto;
  }
`;
